import React, {
  ClassAttributes,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { TbSearch } from 'react-icons/tb';
import { wrap, icon, input } from './style';

interface Props
  extends InputHTMLAttributes<HTMLInputElement>,
    ClassAttributes<HTMLInputElement> {
  css?: Interpolation<Theme>;
}

// css prop 은 Emotion 이 className 으로 변환해 넘기므로 label(외곽)에 적용한다
function SearchInput(
  { className, type, ...props }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <label css={wrap} className={className}>
      <TbSearch size={18} css={icon} aria-hidden />
      <input
        ref={ref}
        type={type ?? 'search'}
        autoComplete="off"
        enterKeyHint="search"
        {...props}
        css={input}
      />
    </label>
  );
}

export default forwardRef(SearchInput);
